import type { FC } from 'react';

import { Button } from '@wwe-portal/ui/components/button';
import {
  Dialog,
  CommonDialogLayout,
  ProgressingDialogHead,
} from '@wwe-portal/ui/components/dialog';

interface ChangePlanDialogProps {
  onClose?: () => void;
  onChange?: () => void;
  isUpgrading: boolean;
  description?: string;
  open?: boolean;
  buttonContent: React.ReactNode;
}
export const ChangePlanDialog: FC<ChangePlanDialogProps> = ({
  onClose,
  onChange,
  isUpgrading,
  description,
  open = true,
  buttonContent,
}) => {
  return (
    <Dialog
      onOpenChange={(isOpen) => {
        if (!isOpen) onClose?.();
      }}
      open={open}
    >
      <CommonDialogLayout
        actionElement={
          buttonContent ? (
            <div className="flex justify-center">
              <Button
                className="w-full max-w-[178px]"
                loading={isUpgrading}
                onClick={onChange}
                variant="orange"
              >
                {buttonContent}
              </Button>
            </div>
          ) : null
        }
        closable
        dataId="ChangePlanDialog"
        descriptionElement={
          <div>
            <span>{description}</span>
          </div>
        }
        imageElement={
          <ProgressingDialogHead duration={0} progressPercent={0} />
        }
        onClose={onClose}
        titleElement={undefined}
      />
    </Dialog>
  );
};
